import BreadCrumb from "Components/Common/BreadCrumb";
import React from "react";
import { Col, Container, Row } from "reactstrap";
import Filters from "../Filters";
import TotalSupport from "../Widgets/TotalSupport";
import TotalContracts from "../Widgets/TotalContracts";
import TotalMDAs from "../Widgets/TotalMDAs";
import TotalPartners from "../Widgets/TotalPartners";
import RegionGenderDistribution from "./RegionGenderDistribution";
import GenderCategoryDistribution from "./GenderCategoryDistribution";
import GenderDistribution from "./GenderDistribution";

const GenderAnalysisReport = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Gender Analysis Report"
            pageTitles={[
              { title: "Dashboard", link: "/dashboard" },
              { title: "Reports" },
            ]}
          />

          <Row>
            <Col lg={12}>
              <Filters />
            </Col>
          </Row>

          <Row>
            <Col lg={3} md={4}>
              <TotalSupport />
            </Col>
            <Col lg={3} md={4}>
              <TotalContracts />
            </Col>
            <Col lg={3} md={4}>
              <TotalMDAs />
            </Col>
            <Col lg={3} md={4}>
              <TotalPartners />
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <RegionGenderDistribution />
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <GenderCategoryDistribution />
            </Col>

            <Col lg={6}>
              <GenderDistribution />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default GenderAnalysisReport;
